import { render, staticRenderFns } from "./SearchNotifications.vue?vue&type=template&id=43d87f3c"
import script from "../../script/search/searchNotifications.js?vue&type=script&lang=js&external"
export * from "../../script/search/searchNotifications.js?vue&type=script&lang=js&external"
import style0 from "../../less/search/search.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports